import {IEnv} from './env';

export const environment: IEnv = {
  production: true,
  apiUrl: 'https://api.dashboard.mindtrust.com',
  googleClientId: '177687006509-b0e4orbn98qc666go0f53pbdm5jbp349.apps.googleusercontent.com'
};
